import { Speed, Delay, Direction } from '@regular_ui/lib/definitions';
import { StyledComponent as HideableStyledComponent } from '@regular_ui/lib/components/hideable/styled-component';
import styled from 'styled-components';

export const slowRevealHideableVariant = {
  name: 'slow',
  props: {
    speed: Speed.Slow,
    delayIn: Delay.Short,
  },
};

const SlideHideable = styled(HideableStyledComponent)<{
  slideDirection: Direction;
}>`
  transition-property: opacity, transform;
  will-change: opacity, transform;
  transform: ${p =>
    p.visible
      ? 'none'
      : {
          [Direction.Up]: 'translateY(-100%)',
          [Direction.Down]: 'translateY(100%)',
          [Direction.Left]: 'translateX(-100%)',
          [Direction.Right]: 'translateX(100%)',
        }[p.slideDirection]};
`;

export const slideHideableVariant = {
  name: 'slide',
  props: {
    speed: Speed.Slow,
    fade: false,
    StyledComponent: SlideHideable,
  },
};

const NudgeUpHideable = styled(HideableStyledComponent)`
  transition-property: opacity, transform;
  will-change: opacity, transform;
  transform: translateY(${p => (p.visible ? '0em' : '-0.25em')});
`;

export const nudgeUpHideableVariant = {
  name: 'nudge-up',
  props: {
    speed: Speed.Slow,
    StyledComponent: NudgeUpHideable,
  },
};
